import { all } from 'typed-redux-saga'
import {
	massUpdateCuratorSaga,
	matrixRoleSaga,
	massUseMerchantSaga,
	contractsRegistrySaga,
	astSaga,
	partnerSaga,
	blackListPartnerSaga,
} from 'Pages/pp'

export function* ppSaga() {
	yield* all([
		massUpdateCuratorSaga(),
		matrixRoleSaga(),
		massUseMerchantSaga(),
		contractsRegistrySaga(),
		astSaga(),
		partnerSaga(),
		blackListPartnerSaga(),
	])
}
